<template>
  <div class="all-style-bgc">
    <div class="container">
      <div class="title-tab">
        <span>当前位置：</span>
        <span @click="GoreportInternet">清风论坛></span>
        <span @click="GoreportEvaluation">他山之石></span>
        <span @click="GoreportOutside">学习他人></span>
        <span class="red">正文</span>
        slot
      </div>
      <!--正文内容-->
      <div class="text">
        <h1>章雪峰：以有力监督为战疫提供纪律保障</h1>
        <h2>
          来源：新华社
          <span class="mg-16">|</span>
          发布时间：2020-03-30&nbsp;13:30
        </h2>
        <h3>疫情是一次大考，情势之急、任务之重、强度之高，对全市各级党组织和全体党员干部作风、能力、素质是一次检验和挑战。从总体上看，我市各级党组织和广大党员干部冲在一线、勇挑重担，经受住了这次考验，交出了合格的答卷。,把信访举报作为纪律审查的线索的第一来源渠道，充分发挥其“预警器”和“晴雨表”作用，注重精准分析，提高办信质效，积极探索化解基层信访问题的新途径、新办法，不断推进信访举报工作高质量发展。</h3>
        <h3>疫情发生以来，全市纪检监察机关聚焦工作重点，强化监督力度，持续开展明察暗访，严肃执纪问责，盯紧基层党建工作中的薄弱环节，为坚决打赢疫情防控阻击战提供有力保障。</h3>
        <h3>
          <b>做到“五紧”：监督有力度，保障防控落地落细</b>
        </h3>
        <h3>(紧跟最新精神，及时研究部署。紧紧围绕中央、省、市委关于疫情防控工作的最新精神，结合本地实际，研究具体措施。成立领导小组和工作专班，统一指挥、集中调度。实行日报告制度，对全市工作情况每天梳理汇总上报省纪委。印发《关于在新型冠状病毒肺炎疫情防控中充分发挥监督专职职能和党员干部作用的通知》《关于严明纪律确保新型冠状病毒肺炎防控工作顺利进行的通知》《关于进一步严明疫情防控战时纪律的通知》，严明疫情防控政治纪律、“两个战场”纪律、人员保护和物资保障纪律、信息公开和宣传舆论纪律等“四项纪律”，从重从快查处“七类问题”。.11%。从村（社区）干部受处理具体案例来分析，两人或两人以上“抱团”违纪现象比较普遍。主要表现为以村支部书记、主任为核心，其他村组干部参与、共同“谋划”的利益“小团体”，成为违纪违法问题的高危群体。如，该市太平镇崔垱村、大王村从村支部书记到村委会委员，集体挪用粮食直补款、坐收坐支集体资金等，涉及村“两委”干部达5人。+体会交流+廉政党课”的方式召开了“一案一教育”警示教育大会，强化警示教育的感染力和说服力。</h3>
        <h3>紧扣中心任务，强化服务保障。牢牢把握“政治机关”这个站位，做到市委决策部署到哪里，监督检查就跟进到哪里。结合阶段性重点工作，开展移动菜篮子、捐赠和上级发放物资使用分配、特殊机构防控、医护人员补贴发放、复工复产等专项检查。对监督检查发现的问题，及时向分管市领导、指挥部相关工作组和市直单位发出工作提醒函，当好参谋。-2018年在担任该所党支部书记、所长期间，违反中央八项规定精神、违反政治纪律、挪用公款、非法占有公共财物等，被群众多次举报。其中违反中央八项规定精神达3次之多，从党内警告处分直至给予留党察看。分析多次被举报受处分人员情况，国家工作人员71人，农村党员干部108人。其中村（社区）主职干部被举报频率较高，受处分达72人，占比40.22%。</h3>
        <h3>紧盯基层一线，常态督导检查。盯住基层一线这个市委决策部署落实的“神经末梢”，检验落实效果，确保落地落细，做到领导下沉常态化、干部下沉常态化、贴身监督常态化。班子成员带头深入镇村明</h3>
        <h3>紧抓突出问题，加强作风建设。为整治疫情防控中各类形式主义问题，减轻基层负担，市纪委对照中央纪委、省纪委最新精神，制定下发《关于进一步突出监督重点，坚决纠治疫情防控中的形式主义官僚主义的通知》，紧盯“五个方面”监督重点，提出一系列抓落实的具体举措。下发《关于严格控制填表报数减轻基层负担的通知》，将需要乡镇、村一级填报表格压缩到3项。严肃整治极少数党员不报到、虚假报到、只报到不参加活动、搞形式主义等问题，发现问题线索47个，党纪政务处分5人，组织处理23人。</h3>
        <h3>紧密问责通报，从严从重从快。在报纸、互联网公开举报电话，鼓励群众提供疫情防控不力等问题线索，按照战时纪律，坚持从严从重从快处理。疫情防控监督中共查处问题808个，市本级下发通报13期，通报案例49起、83人。形成强大震慑，为工作顺利推进提供了坚强纪律保障。</h3>
        <h3>
          <b>警惕“四不”：监督有深度，及时查找短板弱项</b>
        </h3>
        <h3>在监督过程中，我们发现少数党组织和党员干部存在“四不”问题，需要我们在下一步工作中进行加强和改进。.76%，同比增长7.25%。主要原因是由于各地各单位受理信访举报的时间不同，信访人担心信访件未被受理或重视不够，在等待的过程中重复反映问题，导致重复访数量居高不下。2019年越级访15件次，同比下降57.14%。主要原因是枣阳市纪委监委领导班子认真执行定期下访接访制度，主要领导每周四固定接访，去年共接待群众面访36批次581人次，上访对象无一人越级访，有效缓解了全市大信访压力，越级访乱象得到了遏止；二是自办案件增加，上级转交件下降。2019年共受理信访举报995件，同比基本持平。其中本级自收573件，占57.59%，同比增长57.85%；上级转交办422件，占42.41%，同比下降33.02%。主要原因是随着全面从严治党不断向纵深推进，信访干部履职尽责意识不断增强，办信办访能力增强，加之信访渠道的通畅及日益拓宽，干部主动接访、带案下访、重点约访的机制发挥了积极作用，群众在本级信访诉求能够得到有效解决，越级向上反映问题大幅减少。三是信访反映村级干部增加，乡科级干部减少。2019年信访反映村（社区）人员419件，同比增长16.06%，反映乡科级干部198件，同比下降30.5%。从中不难看出在全面从严治党的高压态势下，不敢腐的震慑已经形成，不能腐的笼子正在扎牢，不想腐的自觉逐步增强，但从村干部信访举报持续增长的趋势显示，全面从严治党“最后一米”的问题还不够彻底，违反群众纪律和廉洁纪律类问题仍然居高不下，破坏了党群干群关系，蚕食了群众切身利益。 闵翼飞）</h3>
        <h3>党性不强。疫情期间，纪委监委查处了个别缺乏政治敏感性、不带头遵守防控纪律的领导干部。少数干部不听招呼，违规聚餐，受到了纪律处分，被免去职务。这些党员干部突出特点是在特殊时期政治意识不强、政治规矩不严，执行党的方针政策不坚决不彻底。.26%。从中可以看出“有问题找纪委”的现象还比较普遍，究其原因是信访举报渠道宣传的不细致、不到位，导致部分群众分不清什么问题该在本村（社区）或乡镇就能得到解决，什么问题该找公检法部门，什么问题该找纪委监委，部分群众“病急乱投医”的较为普遍，同时也额外增加了纪检监察机关办信办案工作量。三是能力素质不到位。监察体制改革后，纪委监委合署办公，部分干部尤其是基层纪检干部“熟纪不熟法”，或存在“偏科”“瘸腿”现象，办信办案能力不足，质量不高。再之，有的纪委书记、纪检委员一人身兼数职，对信访工作不上心、不研究、不投入，久而久之，成为了信访工作的“门外汉”，阻碍了信访工作高质量发展。</h3>
        <h3>作风不实。有的工作浮在面上，只安排不督办，会议室里口号喊得震天响，落实起来却轻飘飘。有的行动迟缓，总是“慢一拍”，错过最佳战机，影响工作效果。有的不考虑基层实际，只交任务、不帮助解决问题，甚至以属地管理为名借机“甩锅”。有的粗心大意，工作马虎，造成不良影响。有的加重基层负担，消耗干部抗疫精力，填表报数过多过频过急，电话一打就立即要数字，任务一安排就马上要落实结果。还有极个别公职人员吃拿卡要，借帮助代购配送物资之机加价，损害群众利益。市纪委都处理并通报过相关典型案例。</h3>
        <h3>担当不够。一些党组织和党员干部存在“等、靠、要”思想，不敢担责担难。在疫情防控初期该紧的时候紧不起来，在后期该松的时候松不下去。特殊时期，事无巨细都要等上级给个“明白话”。个别党员在疫情防控工作中，逃避责任，不敢挺身而出，临阵退缩，未能发挥党员先锋模范作用。</h3>
        <h3>办法不多。少数干部突发事件应对能力需要加强，疫情来临后，也有极大的工作热情，但是心中一团火、工作一团麻，想法很多、办法很少，思路不清晰，措施不得力，找不到切入点，抓不住主要矛盾和矛盾的主要方面，工作成效不明显。.9%和90.8%，给予党纪政务处分21人，组织处理384人，清收清退资金395.9万元，推动完善制度147项。</h3>
        <h3>
          <b>　　压实“三责”：监督有合力，筑牢织密责任体系</b>
        </h3>
        <h3>　压实主体责任。各级地方、单位党组织要分别对照《党委（党组）落实全面从严治党主体责任规定》第六、七条关于责任内容的规定，把党的政治建设摆在首位，强化政治领导；把党的思想建设作为基础性建设来抓，纯洁干部队伍，坚定理想信念；加强党的纪律建设，重点强化政治纪律和组织纪律，做到令行禁止。毫不放松加强党员干部的教育管理监督，抓好班子，带好队伍，锤炼作风，提高本领。</h3>
        <h3>压实监督责任。监督是保证党的各项政策落实落地最直接、最有效的方式。各级纪检监察机关作为党内监督专责机关，要切实履行职责，持续开展明察暗访，严肃执纪问责，精准执纪问责，落实“三个区分开来”，既彰显监督力度，又体现监督温度，为坚决打赢疫情防控阻击战提供有力保障。要形成监督合力，把党内监督同国家机关监督、舆论监督、社会监督、审计监督、人大监督、民主监督相结合，发挥“两代表一委员”等各类群体作用，最大程度延伸监督触角。党组织和党员干部要主动接受监督、积极配合监督，对监督指出的问题、提出的意见建议，要认真反思、全面整改，举一反三抓好落实。</h3>
        <h3>压实监管责任。疫情期间，有些职能部门一定程度上出现人员组织无序、平时底数不清、工作衔接不顺、防控力度不够等问题，说明平时工作不够精细，该掌握的情况没有掌握，该完善的环节没有完善，该建立的机制没有建立。要提前谋划，增强危机感，提高预见性，结合建国以来我国面临的重大危机和近年国外发生的重大事件，对照本单位职责，深入反思，查漏洞，补短板，强弱项。.6%、召开会议同比下降31.4%。出台《南漳县纪委关于加强对形式主义、官僚主义整治工作监督检查的办法》，建立“八查”工作法（即刀刃向内自己查、发动群众广泛查、深入基层一线查、确定专题专项查、紧盯关键重点查、派出监督常态查、整合资源联合查、异地互动交叉查），深入推进整治形式主义、官僚主义的各项举措落实落地。2019年以来，全县共查处各类形式主义、官僚主义问题140起，给予党纪政务处分18人，组织处理122人。</h3>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      PicBannertest1: require("../../../../assets/image/bannertest1.jpg"),
      PicBannertest2: require("../../../../assets/image/bannertest2.jpg")
    };
  },
  methods: {
    GoreportInternet() {
      this.$router.push("/forum");
    },
    GoreportEvaluation() {
      this.$router.push({ name: "forumClassroom" });
    },
    GoreportOutside() {
      this.$router.push({ name: "forumOutside" });
    }
  }
};
</script>

<style lang="less" scoped>
.container {
  width: 1200px;
  margin: 0 auto;
}
/*副导航兰*/
.title-tab {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  line-height: 54px;
  cursor: pointer;
}
.red {
  color: red;
}
/*问卷调查正文*/
.text {
  background-color: white;
  padding: 44px 60px 121px 60px;
  margin: 0 auto;
}
.text h1 {
  font-size: 28px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  line-height: 56px;
  text-align: center;
}
.text h2 {
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
  line-height: 44px;
  text-align: center;
  padding-bottom: 14px;
  border-bottom: 1px solid #E8E8E8;
  margin-bottom: 15px;
   text-align: center;
  display: flex;
  justify-content: center;
}
.text h3 {
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  line-height: 32px;
  text-indent: 2em;
  margin-bottom: 30px;
}
/*静态页面样式 */
.PIC-BOX {
  display: flex;
  justify-content: center;
}
.text h3 b {
  display: block;
  margin-top: 20px;
}
img{
  margin: 20px 0px;
}
.mg-16{
  margin: 0px 16px;
}
</style>